"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AvailableTag;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactMintl = require("@godaddy/react-mintl");
var _sharedComponents = require("@site/shared-components");
var _utils = require("@site/utils");
var _uxUtils = require("@site/ux-utils");
var _PremiumSupportPhone = _interopRequireDefault(require("../PremiumSupportPhone"));
/* eslint-disable complexity */

function AvailableTag({
  isLtoDomain = false,
  isAfterMarketDomain = false,
  isStackBundle = false,
  isTagVisible = false,
  tagTextId = '',
  tagTextValues = {},
  dataCy = 'availableCard-tag',
  showBuyingAssistanceText = false,
  isAuctionDomain = false,
  isDesktop = false,
  isMobile = false,
  boostedTagSingleConsolidated = false,
  tagIcon,
  domainSource,
  boostedTagTextId = '',
  boostedTagTextValues,
  boostedTagIcon,
  boostedTagTooltip,
  boostedTagColor,
  premiumColorSchema,
  auctionPhone,
  premiumPhone
}) {
  const getDefaultColor = () => {
    if ([_utils.DOMAIN_SOURCES.AI_SEARCH_TOP_RESULT, _utils.DOMAIN_SOURCES.AI_SEARCH_SECOND_RESULT].includes(domainSource) && !isAfterMarketDomain && !isAuctionDomain) {
      return 'bg-dark-grey text-white';
    }
    if (isStackBundle) return 'bg-chosen';
    return isAfterMarketDomain || isAuctionDomain ? 'bg-light-purple' : 'bg-warning';
  };
  const boostTagComponent = /*#__PURE__*/_react.default.createElement(_sharedComponents.Tag, {
    textId: boostedTagTextId,
    textValues: boostedTagTextValues,
    dataCy: "boosted-aftermarket-tag",
    color: boostedTagColor || (boostedTagSingleConsolidated ? 'bg-light-purple' : 'bg-highlight'),
    icon: boostedTagIcon,
    className: "z-index-1 ms-2 mr-1"
  });
  if (isTagVisible && tagTextId) {
    const tagStyle = premiumColorSchema?.badgeOutlineColor ? {
      outline: `solid 1px ${premiumColorSchema.badgeOutlineColor}`
    } : null;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)('min-h-26-px pb-2', {
        'd-flex flex-wrap': Boolean(boostedTagTextId || boostedTagIcon),
        'gap-3': !isDesktop
      })
    }, !boostedTagSingleConsolidated && /*#__PURE__*/_react.default.createElement(_sharedComponents.Tag, {
      textId: tagTextId,
      textValues: tagTextValues,
      dataCy: dataCy,
      color: premiumColorSchema?.badgeColor || getDefaultColor(),
      icon: premiumColorSchema?.badgeIcon ? (0, _uxUtils.getIcon)({
        icon: premiumColorSchema?.badgeIcon,
        iconSize: 18,
        className: 'mr-1'
      }) : tagIcon,
      style: tagStyle,
      className: "mr-1 ms-2"
    }), (boostedTagTextId || boostedTagIcon) && (boostedTagTooltip ? /*#__PURE__*/_react.default.createElement(_sharedComponents.TooltipWrapper, {
      dataCy: "boost-tag-tooltip",
      tooltipContent: Array.isArray(boostedTagTooltip) ? /*#__PURE__*/_react.default.createElement("ul", null, boostedTagTooltip?.map(rtb => /*#__PURE__*/_react.default.createElement("li", {
        key: rtb
      }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
        id: rtb
      })))) : /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
        id: boostedTagTooltip
      }),
      tooltipButtonText: boostTagComponent,
      id: "boost-tag-tooltip",
      classNames: {
        tooltipButton: 'd-flex'
      },
      openOnHover: !isMobile,
      autoHideTimeout: 1
    }) : boostTagComponent), isLtoDomain && /*#__PURE__*/_react.default.createElement(_sharedComponents.Tag, {
      textId: 'lto.leaseToOwn',
      dataCy: 'lto-tag',
      color: "lto-tag-background-color",
      icon: (0, _uxUtils.getIcon)({
        icon: 'dollar',
        iconSize: 11,
        className: 'mr-1'
      }),
      style: tagStyle,
      className: "mr-1 ms-2",
      classNameOverrides: {
        overrideDisplayInlineFlex: true
      }
    }), showBuyingAssistanceText && /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_PremiumSupportPhone.default, {
      isAuctionDomain: isAuctionDomain,
      cssClasses: 'text-muted ms-1 pl-2',
      auctionPhone: auctionPhone,
      premiumPhone: premiumPhone
    })));
  }
  return null;
}
AvailableTag.propTypes = {
  isTagVisible: _propTypes.default.bool,
  tagTextId: _propTypes.default.string,
  tagTextValues: _propTypes.default.object,
  dataCy: _propTypes.default.string,
  isLtoDomain: _propTypes.default.bool,
  isAfterMarketDomain: _propTypes.default.bool,
  isStackBundle: _propTypes.default.bool,
  showBuyingAssistanceText: _propTypes.default.bool,
  isAuctionDomain: _propTypes.default.bool,
  isDesktop: _propTypes.default.bool,
  isMobile: _propTypes.default.bool,
  tagIcon: _propTypes.default.node,
  domainSource: _propTypes.default.string,
  boostedTagIcon: _propTypes.default.node,
  boostedTagTextId: _propTypes.default.string,
  boostedTagTextValues: _propTypes.default.object,
  boostedTagTooltip: _propTypes.default.string,
  boostedTagSingleConsolidated: _propTypes.default.bool,
  boostedTagColor: _propTypes.default.string,
  premiumColorSchema: _propTypes.default.object,
  auctionPhone: _propTypes.default.string,
  premiumPhone: _propTypes.default.string
};